<div class="header">
  <div class="title">
    <div class="title-text">Medical Notes</div>
  </div>
  <span class="message">* populated from PatientNow</span>
</div>
<hr class="divider" />
<div class="content">
  <fb-simple-table [data]="notes()">
    <ng-container fbSimpleTableColumnDef>
      <ng-template fbSimpleTableHeaderCellDef>Date</ng-template>
      <ng-template fbSimpleTableCellDef let-note>{{ note.date | date: 'MM/dd/yyyy' }}</ng-template>
    </ng-container>
    <ng-container fbSimpleTableColumnDef>
      <ng-template fbSimpleTableHeaderCellDef>Employee</ng-template>
      <ng-template fbSimpleTableCellDef let-note>{{ note.employeeName || note.employeeId }}</ng-template>
    </ng-container>
    <ng-container fbSimpleTableColumnDef>
      <ng-template fbSimpleTableHeaderCellDef>Medical Note</ng-template>
      <ng-template fbSimpleTableCellDef let-note>
        <span class="medical-note-cell">
          <span>{{ note.text }}</span>
          <fb-scribe-suggestion-indicator
            [target]="getNoteMarkerTarget(note)"
            variant="compact"
          ></fb-scribe-suggestion-indicator>
          <fb-amendment-field-indicator [rowIndex]="getAmendmentRowIndex(note)" />
        </span>
      </ng-template>
    </ng-container>
  </fb-simple-table>
  @if (showNoDataMessage()) {
    <span class="message">* Populated from PatientNow - Patient has no data</span>
  }
</div>
<hr class="divider" />
<button type="button" class="action" (click)="presentDialog()">
  <rx-icon name="icon-circle-plus-2" class="action-icon" />
  <span class="action-label">Add Medical Note</span>
</button>
